<template>
    <div class="modal fade modal-dialog-scrollable" id="editEntryModal" tabindex="-1"
        aria-labelledby="editEntryModalLabel" aria-hidden="true" style="z-index: 9999;">
        <div class="modal-dialog" style="max-height: calc(100vh - 150px); margin-top: 10px; margin-bottom: 120px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editEntryModalLabel">エントリ変更</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        tabindex="-1"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <label class="col-5 form-label px-2">エントリ番号:</label>
                        <div class="col-7"><span style="color:red; font-weight: 800">{{ selectedEntryId }}</span>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <table class="table table-bordered align-middle">
                            <thead>
                                <tr>
                                    <th>チーム</th>
                                    <th>選手</th>
                                    <th>カナ</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr>
                               <td style="min-width: 100px;">
                                    <div class="form-check form-check-inline p-0 m-0">
                                        <select class="form-select" aria-label="select-team" id="teamSelected" v-model="selectedEntry.team_id_1">
                                            <option value=""></option>
                                            <option v-for="(team, index) in teamList" :value="index">{{ team.name }}</option>
                                        </select>
                                    </div>
                                </td>
                                <td><input type="text" v-model="selectedEntry.player_name_1"></td>
                                <td><input type="text" v-model="selectedEntry.player_kana_1" placeholder="かな"></td>
                            </tr>
                            <tr>
                               <td>
                                    <div class="form-check form-check-inline p-0 m-0">
                                        <select class="form-select" aria-label="select-team" id="teamSelected" v-model="selectedEntry.team_id_2">
                                            <option value=""></option>
                                            <option v-for="(team, index) in teamList" :value="index">{{ team.name }}</option>
                                        </select>
                                    </div>
                                </td>
                                <td><input type="text" v-model="selectedEntry.player_name_2"></td>
                                <td><input type="text" v-model="selectedEntry.player_kana_2" placeholder="かな"></td>
                            </tr>

                        </tbody>
                        </table>
                    </div>
                    <div v-if="showLeagueResultsFlag" class="row" style="border-top: 1px solid #dee2e6; padding-top: 1rem;">
                        <div class="col-12">
                            <h6>リーグ戦結果</h6>
                            <div v-if="isLoadingLeagueResults" class="text-center py-3">
                                <div class="spinner-border spinner" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else style="max-height: 300px; overflow-y: auto;">
                                <table class="table table-sm table-bordered text-center">
                                    <thead>
                                        <tr>
                                            <th style="width: 60px;">リーグ</th>
                                            <th style="width: 50px;">順位</th>
                                            <th style="width: 120px;">チーム</th>
                                            <th>選手名</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(entry, key, index) in leagueResults" :key="key" @dblclick="copyEntryToForm(entry)" style="cursor: pointer;">
                                            <td style="width: 60px;">{{ shouldShowEventId(index, entry.event_id) ? entry.event_id : '' }}</td>
                                            <td style="width: 50px;">{{ entry.rank }}</td>
                                            <td style="text-align: left; width: 120px;">
                                                <TeamLabelComponent v-if="entry.team_id_1 !== ''" :teamId="entry.team_id_1" />
                                                <TeamLabelComponent v-if="entry.team_id_2 !== '' && entry.team_id_1 !== entry.team_id_2" :teamId="entry.team_id_2" />
                                            </td>
                                            <td style="text-align: left;">
                                                {{ entry.player_name_1 }}
                                                <span v-if="entry.player_name_2 && entry.player_name_2 !== ''"> / {{ entry.player_name_2 }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer">
                    <div style="display: flex; justify-content: space-between; width: 100%;">
                        <div style="width:50%; text-align:left;"><button type="button" class="btn btn-sm btn-secondary" tabindex="5" data-bs-dismiss="modal">キャンセル</button></div>
                        <div style="width:50%; text-align:right;">
                            <div class="form-check form-switch d-inline-block me-2">
                                <input class="form-check-input" type="checkbox" id="leagueResultsSwitch" tabindex="4" v-model="showLeagueResultsFlag" @change="showLeagueResults()">
                                <label class="form-check-label" for="leagueResultsSwitch">リーグ戦結果表示</label>
                            </div>
                            <button type="button" class="btn btn-sm btn-primary" tabindex="3" data-bs-dismiss="modal" @click="saveEntryValue()">保存する</button>
                        </div>
                    </div>
                    <div>
                        <span v-if="errorMessage" style="color: red"><br> {{ errorMessage }} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="text-center" v-if="isLoading">
        <div class="spinner-border spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { ref as fbRef, getDatabase, child, get, update } from "firebase/database"
import { getAuth } from "firebase/auth";
import TeamLabelComponent from './TeamLabelComponent.vue';
const auth = getAuth();
const user = auth.currentUser;
const teamList = ref([]);
const db = getDatabase();
const dbRef = fbRef(db);
const isLoading = ref()
const errorMessage = ref();
const showLeagueResultsFlag = ref(false);
const leagueResults = ref([]);
const isLoadingLeagueResults = ref(false);
const props = defineProps(['selectedEntryId', 'selectedEntry']);
const emit = defineEmits(["doReload"])

onMounted(() => {
    teamList.value = JSON.parse(localStorage.getItem("teams"))
})

watch(() => props.selectedEntry, () => {
    if (showLeagueResultsFlag.value) {
        fetchLeagueResults();
    }
})

const showLeagueResults = () => {
    if (showLeagueResultsFlag.value) {
        console.log("リーグ戦結果を表示");
        fetchLeagueResults();
    } else {
        console.log("リーグ戦結果を非表示");
        leagueResults.value = [];
    }
}

const shouldShowEventId = (index, eventId) => {
    if (index === 0) return true;
    const entries = Object.values(leagueResults.value);
    return entries[index - 1].event_id !== eventId;
}

const copyEntryToForm = (entry) => {
    if (props.selectedEntry) {
        props.selectedEntry.team_id_1 = entry.team_id_1;
        props.selectedEntry.team_id_2 = entry.team_id_2;
        props.selectedEntry.player_name_1 = entry.player_name_1;
        props.selectedEntry.player_name_2 = entry.player_name_2 || '';
        props.selectedEntry.player_kana_1 = entry.player_kana_1 || '';
        props.selectedEntry.player_kana_2 = entry.player_kana_2 || '';
        console.log("エントリをフォームにコピー:", entry);
    }
}

const fetchLeagueResults = async () => {
    // 現在のエントリのevent_idからgradeを取得
    isLoadingLeagueResults.value = true;
    const currentEventId = props.selectedEntry.event_id;
    let currentGrade;
    let leagueEventIds;
    await get(child(dbRef, '/2026-summer/events/' + currentEventId))
        .then((snapshot) => {
            if (snapshot.exists()) {
                const currentEvent = snapshot.val();
                currentGrade = currentEvent.grade;
                console.log("Current grade:", currentGrade);

                // 同じgradeのリーグ戦イベントを取得
                return get(child(dbRef, '/2026-summer/events'));
            } else {
                console.error("Event not found:", currentEventId);
                throw new Error("Event not found");
            }
        })
        .then((snapshot) => {
            if (snapshot && snapshot.exists()) {
                const allEvents = snapshot.val();
                const leagueEvents = Object.fromEntries(
                    Object.entries(allEvents)
                        .filter(([key, value]) => value.method === "リーグ" && value.grade === currentGrade)
                );

                // リーグ戦のevent_idsを取得
                const leagueEventIds = Object.keys(leagueEvents);

                // localStorageからentriesを取得
                const allEntries = JSON.parse(localStorage.getItem("entries"));
                if (allEntries) {
                    const leagueEntries = Object.fromEntries(
                        Object.entries(allEntries)
                            .filter(([key, value]) => leagueEventIds.includes(value.event_id))
                            .sort(function (a, b) {
                                if (a[1].event_id < b[1].event_id) { return -1 }
                                if (a[1].event_id > b[1].event_id) { return 1 }
                                if (a[1].rank < b[1].rank) { return -1 }
                                if (a[1].rank > b[1].rank) { return 1 }
                                return 0
                            })
                    );
                    leagueResults.value = leagueEntries;
                    console.log("League results:", leagueResults.value);
                } else {
                    console.error("Entries not found in localStorage");
                }
            }
        })
        .catch((error) => {
            console.error("Error fetching league results:", error);
        })
        .finally(() => {
            isLoadingLeagueResults.value = false;
        });
}

const saveEntryValue = async () => {

    if (user && user.email) {
        isLoading.value = ref(true);
    
        const new_entry = ref([]);
        await get(child(dbRef, '/2026-summer/entries/' + props.selectedEntryId))
        .then(async (snapshot) => {
            if (snapshot.exists()) {
                new_entry.value = snapshot.val();
                new_entry.value.player_name_1 = props.selectedEntry.player_name_1;
                new_entry.value.team_id_1 = props.selectedEntry.team_id_1;
                new_entry.value.player_kana_1 = props.selectedEntry.player_kana_1 || '';
                if (props.selectedEntry.player_name_2) {
                    new_entry.value.player_name_2 = props.selectedEntry.player_name_2;
                    new_entry.value.team_id_2 = props.selectedEntry.team_id_2;
                    new_entry.value.player_kana_2 = props.selectedEntry.player_kana_2 || '';
                } else {
                    new_entry.value.player_name_2 = '';
                    new_entry.value.team_id_2 = '';
                    new_entry.value.player_kana_2 = '';
                }
                const updates = {};
                updates['/2026-summer/entries/' + props.selectedEntryId] = new_entry.value;
                await update(dbRef, updates)
                .then( async () => {
                    console.log("Entry(" + props.selectedEntryId + ") updated succssfully.");
                })
                .catch((error) => {
                    console.error(error)
                    throw (error)
                });
            } else {
                console.warn("No entry data " + props.selectedEntryId)
            }
        }).then(async () => {
            await get(child(dbRef, '/2026-summer/entries'))
            .then((snapshot) => {
                if (snapshot.exists()) {
                    localStorage.setItem('entries', JSON.stringify(snapshot.val()));
                } else {
                    console.log('No data available')
                }
            }).catch((error) => {
                console.error(error)
            })
        }).then(async () => {
            await updateMatch(props.selectedEntryId, new_entry)
        }).catch((error) => {
            errorMessage = error
            console.error(error)
        }).finally(async () => {
            // console.log("doing reload")
            emit('doReload');
            isLoading.value = false;
        })
    }
}

const updateMatch = async (target_entry_id, new_entry) => {
    const allMatches = JSON.parse(localStorage.getItem("matches"));
    const availableMatches = ref([]);
    availableMatches.value = allMatches;
    availableMatches.value = Object.fromEntries(
        Object.entries(availableMatches.value).filter(([key, value]) =>
        ((target_entry_id == (value.event_id + "-" + value.left_entry_id)) || (target_entry_id == (value.event_id + "-" + value.right_entry_id)))),
    );
    // console.log("matches: " + JSON.stringify(availableMatches.value))

    const availableMatchesObj = JSON.parse(JSON.stringify(availableMatches.value));
    for (var match_key in availableMatchesObj) {
        // console.log(match_key)
        const match = ref([]);
        await get(child(dbRef, '/2026-summer/matches/' + match_key))
            .then(async (snapshot) => {
                if (snapshot.exists()) {
                    match.value = snapshot.val();
                    if (match.value.event_id + "-" + match.value.left_entry_id == target_entry_id) {
                        match.value.left_player_name_1 = new_entry.value.player_name_1;
                        match.value.left_team_id_1 = new_entry.value.team_id_1;
                        match.value.left_player_name_2 = new_entry.value.player_name_2 || '';
                        match.value.left_team_id_2 = new_entry.value.team_id_2 || '';
                    }
                    if (match.value.event_id + "-" + match.value.right_entry_id == target_entry_id) {
                        match.value.right_player_name_1 = new_entry.value.player_name_1;
                        match.value.right_team_id_1 = new_entry.value.team_id_1;
                        match.value.right_player_name_2 = new_entry.value.player_name_2 || '';
                        match.value.right_team_id_2 = new_entry.value.team_id_2 || '';
                    }
                    const updates = {};
                    updates['/2026-summer/matches/' + match_key] = match.value;
                    await update(dbRef, updates)
                        .then(async () => {
                            console.log("match(" + match_key + ") team and player was updated succssfully.")
                        })
                        .catch((error) => {
                            console.error(error)
                            throw(error)
                        });
                }
            }).catch((error) => {
                errorMessage.value = error
                console.error(error)
            })

    }

    // Firebase から最新の matches を取得して localStorage を更新
    await get(child(dbRef, '/2026-summer/matches'))
        .then((snapshot) => {
            if (snapshot.exists()) {
                localStorage.setItem('matches', JSON.stringify(snapshot.val()));
            } else {
                console.log('No match data available')
            }
        }).catch((error) => {
            console.error(error)
        })
}
</script>

<style scoped>
.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}
</style>